import { EngagementErrorDialogDataModel } from './engagement-error-dialog-data.model';

export class DocumentUnderRevisionStrategyModel implements EngagementErrorDialogDataModel {

  engagementId: number;

  constructor(engagementId: number) {
    this.engagementId = engagementId;
  }

  getTitle() { return 'Sorry, this document is currently under revision.'; }
  getMessage() { return 'When a new version is ready for review, you will be notified.'; }
  getImagePath() { return 'under-revision.png'; }
  getButtonText() { return 'Okay'; }
  getRoutePath() { return ''; }
}
